/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconKettlebell: {
  name: 'kettlebell';
  data: string;
} = {
  name: 'kettlebell',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 612 612"><path d="M461.047 231.173h-78.136c12.404-16.279 19.992-36.093 19.992-58.144 0-53.523-43.389-96.912-96.912-96.912s-96.912 43.389-96.912 96.912c0 22.051 7.588 41.864 19.992 58.144h-78.12L34.665 502.5h542.67L461.047 231.173zm-155.055 0c-32.12 0-58.144-26.023-58.144-58.144 0-32.088 26.04-58.144 58.144-58.144 32.12 0 58.144 26.023 58.144 58.144s-26.024 58.144-58.144 58.144z"/></svg>`,
};
